// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
import * as Curry from "bs-platform/lib/es6/curry.js";
import * as Faker from "faker";
import * as Caml_option from "bs-platform/lib/es6/caml_option.js";

function alphaNumeric(count, param) {
  return Curry._1(Faker.random.alphaNumeric, count);
}

function $$boolean(param) {
  return Curry._1(Faker.random.boolean, undefined);
}

function image(param) {
  return Curry._1(Faker.random.image, undefined);
}

function locale(param) {
  return Curry._1(Faker.random.locale, undefined);
}

function number(minOpt, maxOpt, precisionOpt, param) {
  var min = minOpt !== undefined ? minOpt : 0;
  var max = maxOpt !== undefined ? maxOpt : 99999;
  var precision = precisionOpt !== undefined ? precisionOpt : 1;
  return Curry._1(Faker.random.number, {
    min: min,
    max: max,
    precision: precision
  });
}

function uuid(param) {
  return Curry._1(Faker.random.uuid, undefined);
}

function word(param) {
  return Curry._1(Faker.random.word, undefined);
}

function words(count, param) {
  return Curry._1(Faker.random.words, count);
}

function arrayElement(array) {
  return Caml_option.nullable_to_opt(Faker.random.arrayElement(array));
}

export { alphaNumeric, arrayElement, $$boolean, image, locale, number, uuid, word, words };
/* faker Not a pure module */